import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import { numberConvert } from "@website/utils/number-convert";
import snappProBadge from "@website/widget/header/assets/pro_badge.svg";
import { FC } from "react";
import { SnappProDiscountChipProperties } from "./snapp-pro-discount-chip.types";
export const SnappProDiscountChip: FC<SnappProDiscountChipProperties> = t0 => {
  const $ = _c(5);
  const {
    percentage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LazyImage src={snappProBadge.src} alt="Snapp Pro" loading="eager" fetchPriority="high" width={24} height={13} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== percentage) {
    t2 = typeof percentage === "number" ? `%${numberConvert(percentage, {
      locale: "fa"
    })}` : percentage;
    $[1] = percentage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="bg-light-mode-pro-light flex h-[17px] flex-row items-center gap-1 rounded-3xl p-[2px]">{t1}<span className="text-light-mode-pro text-[10px] font-medium">{t2}</span></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};